import { Component, OnInit } from '@angular/core';
import { ShareDataService } from '../../services/share-data.service';
import * as _ from 'lodash';
import { HttpService } from 'src/app/services/http.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-azure-step1',
  templateUrl: './azure-step1.component.html',
  styleUrls: ['./azure-step1.component.scss']
})
export class AzureStep1Component implements OnInit {
  servers: any = [];
  serverCount = 0;

  databases: any = [];
  databaseCount = 0;

  storages: any = [];
  storageCount = 0;
  Environment = "Physical Server";

  network = 1;
  selectedServers: any = [true, false, false];
  dbEnginOptionBackUp: any = [];
  constructor(
    public shareDataService: ShareDataService,
    private httpService: HttpService,
    private spinner: NgxSpinnerService
  ) {
    // console.log('Step 1..');
    this.servers = this.shareDataService.setep1.servers;
    this.databases = this.shareDataService.setep1.databases;
    this.storages = this.shareDataService.setep1.storages;
    this.Environment = this.shareDataService.Environment;
    if (this.shareDataService.selectedServers[0] === 'aws') {
      this.selectedServers[0] = true;
    } else {
      this.selectedServers[0] = false;
    }

    if (this.shareDataService.selectedServers[1] === 'azure') {
      this.selectedServers[1] = true;
    } else {
      this.selectedServers[1] = false;
    }

    if (this.shareDataService.selectedServers[2] === 'gcp') {
      this.selectedServers[2] = true;
    } else {
      this.selectedServers[2] = false;
    }

    if (!this.shareDataService.consts.workload) {
      this.spinner.show();
    }
    !this.shareDataService.consts.workload && this.httpService.get('prod/constants').subscribe((res: any) => {
      this.shareDataService.getConstValues(res);
      this.httpService.get('prod/rangevalidation').subscribe((data: any) => {
        this.shareDataService.getRangeValidation(data);
        this.dbEnginOptionBackUp = this.shareDataService.data.database.DBEngine;
        
        if (this.servers.length === 0) {
          this.addServer()
        }
    
        if (this.databases.length === 0) {
          this.addDatabase()
        }
    
        if (this.storages.length === 0) {
          this.addStorage()
        }
        this.spinner.hide();
      });
      // this.getRangeValidation();
    });
  }

  ngOnInit(): void {
    this.dbEnginOptionBackUp = this.shareDataService.data.database.DBEngine;
    window.scrollTo(0, 0)
  }

  onChangeServerUtilization(index:any){
    this.servers[index].maxUtilization = (730 / this.servers[index].utilizationType).toFixed(0);
    this.servers[index].utilization = this.servers[index].maxUtilization;

  }

  serverUtilizationInputDone(index:any){
    if(this.servers[index].utilization < 1){
      this.servers[index].utilization = 1;
    }else if(this.servers[index].utilization > this.servers[index].maxUtilization){
      this.servers[index].utilization = this.servers[index].maxUtilization;
    }
  }

  onChangeDatabaseUtilization(index:any){
    this.databases[index].maxUtilization = (730 / this.databases[index].utilizationType).toFixed(0);
    this.databases[index].utilization = this.databases[index].maxUtilization;

  }

  databaseUtilizationInputDone(index:any){
    if(this.databases[index].utilization < 1){
      this.databases[index].utilization = 1;
    }else if(this.databases[index].utilization > this.databases[index].maxUtilization){
      this.databases[index].utilization = this.databases[index].maxUtilization;
    }
  }


  onChangeOs(osValue:any,database:any){
    let serviceId:any;
    this.shareDataService.data.database.OS.forEach((os:any) => {
      if(os.Value == osValue){
        serviceId = os.ServiceID;
      }
    });
    database.databaseEnginList=this.dbEnginOptionBackUp.filter((p:any)  => p.ServiceID == serviceId);
    database.DBEngine = database.databaseEnginList[0].Value;
  }
  serverTypesSelect(event: any, index: number): void {
    const value = event.target.value;
    this.selectedServers[index] = value;
  }

  addServer(): void {
    this.serverCount = this.serverCount + 1;
    const server: any = {
      id: this.serverCount,
      name: 'Server ' + (this.servers.length + 1),
      show: true,
      workload: 54,
      Environment: this.Environment,
      OS: 'Windows (BYOL)',
      license: 'Standard',
      serversNumber: 1,
      NoOfProcs: 1,
      NoOfCores: 1,
      ram: 1,
      optimizedBy: 17,
      GPU: 59,
      Hypervisor: 'VMware',
      NumberOfVms: 1,
      DBEngine: '',
      utilizationType:1,
      utilization: 730,
      maxUtilization:730
    };
    this.servers.push(server);
  }

  addDatabase(): any {
    this.databaseCount = this.databaseCount + 1;
    const database: any = {
      id: this.databaseCount,
      name: 'Database ' + (this.databases.length + 1),
      show: true,
      database: 61,
      Hypervisor: 'VMware',
      Environment: this.Environment,
      OS: 'Windows (BYOL)',
      license: 'Standard',
      serversNumber: 1,
      NumberOfVms: 1,
      NoOfProcs: 1,
      NoOfCores: 1,
      ram: 1,
      optimizedBy: 17,
      GPU: 59,
      service: 69,
      servicetier: 73,
      purchasemodel: 72,
      sqlstorage: 5,
      instancecores: 76,
      serversNumberType: 1,
      sqlstorageType: 1,
      DBEngine: 'SQL Server Standard (BYOL)',
      databaseEnginList:[],
      utilizationType:1,
      utilization: 730,
      maxUtilization:730
    };
    this.databases.push(database);
    this.onChangeOs(database.OS,database);
  }

  addStorage(): void {
    this.storageCount = this.storageCount + 1;
    const storage: any = {
      id: this.storageCount,
      name: 'Storage ' + (this.storages.length + 1),
      show: true,
      Storage: 'SAN',
      DiskType: 'HDD',
      Capacity: 1,
      BackUp: 1,
      Archive: 1,
      capacityType: 1,
      archiveType: 1,
      backupType: 1,
      Accessibility: 100,
      MaxIops: 0
    };
    this.storages.push(storage);
  }

  storageTypeChange(event: any, key: string, index: number): any {
    this.storages[index][key] = Number(event);
  }

  databaseTypeChange(event: any, key: string, index: number): any {
    this.databases[index][key] = Number(event);
  }

  storageTypeChangeInNetwork(event: any): void {
    this.network = Number(event);
  }

  onSToggleClick(index: any): void {
    this.servers[index].show = !this.servers[index].show;
  }

  onDatabaseToggleClick(index: any): void {
    this.databases[index].show = !this.databases[index].show;
  }

  onSTorageToggleClick(index: any): void {
    this.storages[index].show = !this.storages[index].show;
  }

  onSDeleteClick(id: any): void {
    _.remove(this.servers, ['id', id]);
  }

  onDatabaseDeleteClick(id: any): void {
    _.remove(this.databases, ['id', id]);
  }

  onSTorageDeleteClick(id: any): void {
    _.remove(this.storages, ['id', id]);
  }

  selectPlatform(event: any, i: number): void {
    setTimeout(() => {
      // console.log(this.selectedServers);
      if (_.filter(this.selectedServers, (item: any)=> item).length == 0) {
        alert('You have to select at least one providers')
        this.selectedServers[i] = true;
      }
      // if (_.filter(this.selectedServers, (item: any)=> item).length > 2) {
      //   alert('Maximum you can select 2 providers')
      //   this.selectedServers[i] = false;
      // }
    }, 0)
  }

  serverRamInputDone(event: any, index: number): void {
    if (this.Environment === 'Physical Server') {
      if (this.servers[index].ram < 1) {
        this.servers[index].ram = 1;
      } else if (this.servers[index].ram > 256) {
        this.servers[index].ram = 256;
      }
    } else {
      if (this.servers[index].ram < 1) {
        this.servers[index].ram = 1;
      } else if (this.servers[index].ram > 512) {
        this.servers[index].ram = 512;
      }
    }
  }



  databaseRamInputDone(event: any, index: number): void {
    if (this.Environment === 'Physical Server') {
      if (this.databases[index].ram < 1) {
        this.databases[index].ram = 1;
      } else if (this.databases[index].ram > 256) {
        this.databases[index].ram = 256;
      }
    } else {
      if (this.databases[index].ram < 1) {
        this.databases[index].ram = 1;
      } else if (this.databases[index].ram > 512) {
        this.databases[index].ram = 512;
      }
    }
  }


  // serverUtilizaionInputDone(event: any, index: number):void {
  //   this.servers[index].utilization = 
  // }

  numberOfServerInputDone(index: number): void {
    if (this.servers[index].serversNumber < 1) {
      this.servers[index].serversNumber = 1;
    } else if (this.servers[index].serversNumber > 10000) {
      this.servers[index].serversNumber = 10000;
    }
  }

  numberOfDatabaseInputDone(index: number): void {
    if (this.databases[index].serversNumber < this.shareDataService.data.database.serversNumber.Min) {
      this.databases[index].serversNumber = this.shareDataService.data.database.serversNumber.Min;
    } else if (this.databases[index].serversNumber > this.shareDataService.data.database.serversNumber.Max) {
      this.databases[index].serversNumber = this.shareDataService.data.database.serversNumber.Max;
    }
  }

  numberOfVMsInputDone(index: number): void {
    if (this.servers[index].NumberOfVms < 1) {
      this.servers[index].NumberOfVms = 1;
    } else if (this.servers[index].NumberOfVms > 10000) {
      this.servers[index].NumberOfVms = 10000;
    }
  }

  numberOfVMsInDBInputDone(index: number): void {
    if (this.databases[index].NumberOfVms < 1) {
      this.databases[index].NumberOfVms = 1;
    } else if (this.databases[index].NumberOfVms > 10000) {
      this.databases[index].NumberOfVms = 10000;
    }
  }

  numberOfServerCoreInputDone(index: number): void {
    if (this.servers[index].NoOfCores < 1) {
      this.servers[index].NoOfCores = 1;
    } else if (this.servers[index].NoOfCores > 96) {
      this.servers[index].NoOfCores = 96;
    }
  }

  numberOfServerCoreInputInDBDone(index: number): void {
    if (this.databases[index].NoOfCores < 1) {
      this.databases[index].NoOfCores = 1;
    } else if (this.databases[index].NoOfCores > 96) {
      this.databases[index].NoOfCores = 96;
    }
  }

  storageCapacitySet(index: number): void {
    if (this.storages[index].Capacity < Number(this.shareDataService.data.storage.Capacity.Min)*Number(this.storages[index].capacityType)) {
      this.storages[index].Capacity = Number(this.shareDataService.data.storage.Capacity.Min)*Number(this.storages[index].capacityType);
    } else if (this.storages[index].Capacity > Number(this.shareDataService.data.storage.Capacity.Max)*Number(this.storages[index].capacityType)) {
      this.storages[index].Capacity = Number(this.shareDataService.data.storage.Capacity.Max)*Number(this.storages[index].capacityType);
    }
  }

  next(): void {
    this.shareDataService.setep1 = {
      servers: this.servers,
      databases: this.databases,
      storages: this.storages,
      network: this.network
    };
    this.shareDataService.Environment = this.Environment;

    if (this.selectedServers[0]) {
      this.shareDataService.selectedServers[0] = 'aws';
    } else {
      this.shareDataService.selectedServers[0] = 'none';
    }
    
    if (this.selectedServers[1]) {
      this.shareDataService.selectedServers[1] = 'azure';
    } else {
      this.shareDataService.selectedServers[1] = 'none';
    }

    if (this.selectedServers[2]) {
      this.shareDataService.selectedServers[2] = 'gcp';
    } else {
      this.shareDataService.selectedServers[2] = 'none';
    }

    if ((this.servers.length + this.databases.length) === 0) {
      alert('Please provide server or database');
    } else if (this.storages.length === 0) {
      alert('Please provide storage');
    } else {
      this.shareDataService.step = 2;
    }

  }

}
